import { createI18n } from 'vue-i18n'
import csCommon from '@lib/i18n/cs/common'
import enCommon from '@lib/i18n/en/common'
import csNav from './cs/nav'
import enNav from './en/nav'
import csDashboard from './cs/dashboard'
import enDashboard from './en/dashboard'
import csDevices from './cs/devices'
import enDevices from './en/devices'
import csEvents from './cs/events'
import enEvents from './en/events'
import csHelp from './cs/help'
import enHelp from './en/help'
import csStatistics from './cs/statistics'
import enStatistics from './en/statistics'
import csTicketsets from './cs/ticketsets'
import enTicketsets from './en/ticketsets'
import csTickets from './cs/tickets'
import enTickets from './en/tickets'
import csUsers from './cs/users'
import enUsers from './en/users'
import csClipboard from './cs/clipboard'
import enClipboard from './en/clipboard'
import csZones from './cs/zones'
import enZones from './en/zones'

const messages = {
    cs: {
        common: csCommon,
        dashboard: csDashboard,
        devices: csDevices,
        events: csEvents,
        help: csHelp,
        nav: csNav,
        statistics: csStatistics,
        ticketsets: csTicketsets,
        tickets: csTickets,
        users: csUsers,
        clipboard: csClipboard,
        zones: csZones
    },
    en: {
        common: enCommon,
        dashboard: enDashboard,
        devices: enDevices,
        events: enEvents,
        help: enHelp,
        nav: enNav,
        statistics: enStatistics,
        ticketsets: enTicketsets,
        tickets: enTickets,
        users: enUsers,
        clipboard: enClipboard,
        zones: enZones
    }
}

export const i18n = createI18n({
    legacy: false,
    locale: localStorage.getItem('adminLocale') ?? 'cs',
    fallbackLocale: 'en',
    messages
})

export function setI18nLocale(code: string) {
    i18n.global.locale.value = code as 'cs' | 'en'
    localStorage.setItem('adminLocale', code)
}
